<template>
  <div v-show="showVoice" ref="voiceRef" @click="handlePlay" class="vocie" :style="length ? 'width:' + length: ''">
    <div class="vocieAinBox">
      <div
        class="vocieAin"
        :class="audioStatus === 'playing' ? 'play' : 'stop'"
      >
        <div class="voice" :class="{active: audioStatus === 'playing'}"></div>
      </div>
    </div>
    <span v-show="duration >= 0">
      {{ duration }}''
    </span>
  </div>
</template>

<script>
import AmrPlayer from '@/utils/AmrPlayer'
const voiceListMap = new Map()

export default {
  props: {
    src: {
      type: String,
      require: false,
      default: undefined,
    },
    msgId: {
      type: [Number, String],
      require: false,
      default: undefined,
    },
    /** 音频时长不一定有 */
    voiceLength: {
      type: [Number, String],
      require: false,
      default: undefined,
    },
  },
  data() {
    return {
      length: undefined,
      audioStatus: undefined,
      duration: undefined,
      isSendRead: false,
      amrInstance: null,
      isInit: false,
      voiceListMap,
      isPC: true
    }
  },
  computed: {
    isAmr() {
      const { src } = this
      return src.indexOf('.amr') > -1
    },
    voiceRef() {
      return this.$refs?.voiceRef
    },
    showVoice() {
      const { isAmr, isInit } = this
      if (!isAmr) return true
      return isInit
    },
  },
  watch: {
    src: {
      handler(value) {
        if (value) {
          this.init()
        }
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    this.amrInstance.pause()
    this.amrInstance = null
  },
  methods: {
    init() {
      const { isAmr } = this

      if (isAmr) {
        this.$nextTick(() => {
          this.initAmr()
        })
        return
      }
    },
    initAmr() {
      const {
        src, voiceRef, playOrPauseOrResume, getDuration, getIsInit, onEnd, pauseAmr,
      } = this
      const params = {
        src,
        el: voiceRef,
        isCeil: true, // 是否向上取整
        bindEvent: {
          playOrPauseOrResume,
          getDuration,
          getIsInit,
          onEnd,
          pause: pauseAmr,
        },
      }
      this.amrInstance = new AmrPlayer(params)
      voiceListMap.set(this.msgId, this.amrInstance)
    },
    pauseAmr(data) {
      this.handleVoiceStatus(data)
    },
    handleVoiceStatus(data) {
      const { isPaused, isPlaying, eventName } = data
      console.log(eventName, 'isPaused:', isPaused, 'isPlaying:', isPlaying, 'handleVoiceStatus')
      if (isPlaying) {
        this.audioStatus = 'playing'
      }
      if (isPaused) {
        this.audioStatus = 'paused'
      }
      if (!isPlaying && !isPaused) {
        this.audioStatus = 'over'
      }
    },
    onEnd(data) {
      this.handleVoiceStatus(data)
    },
    playOrPauseOrResume(data = {}) {
      this.handleVoiceStatus(data)
    },
    getDuration({ duration }) {
      this.duration = duration
      this.handleVoiceLength(duration)
    },
    getIsInit({ isInit }) {
      this.isInit = isInit
    },
    play(data = {}) {
      this.handleVoiceStatus(data)
    },
    handleVoiceLength(duration) {
      const { isPC } = this

      const lengthConfig = {
        unit: isPC ? 'px' : 'vw',
        maxLength: isPC ? 240 : 50,
        minLength: isPC ? 30 : 10,
      }

      const { unit, maxLength, minLength } = lengthConfig

      // let len = (duration / 60) * lengthConfig.maxLength;
      let len = (duration / 60) * (maxLength - minLength) + minLength

      if (len < minLength) {
        len = minLength
      }

      if (len > maxLength) {
        len = maxLength
      }

      this.length = `${len}${unit}`
    },
    loopTime() {
      if (this.audioStatus !== 'playing' || this.duration <= 0) return

      this.duration -= 1
      setTimeout(() => {
        this.loopTime()
      }, 1000)
    },
    countLength(duration) {
      // 计算语音条长度
      if (duration > 30) {
        const len = this.isPC ? '240px' : '60vw'
        this.length = len
      } else {
        const length = parseInt(duration * 2, 10)
        if (length > 11) this.length = `${length}vw`
      }
    },
    preload() {
      if (!(typeof this.sourceDuration === 'undefined')) return
      this.pause()
    },
    /** 安卓自动播放可能会延时 */
    pause() {
      if (this.audioStatus === 'playing') {
        setTimeout(() => {
          this.pause()
        }, 200)
      }
    },
    handlePlay() {
      console.log(this.audioStatus, 'this.audioStatus')
      if (this.audioStatus !== 'playing') {
        voiceListMap.forEach((value, key) => {
          if (key !== this.msgId) {
            value.pause()
          }
        })
      }
    }
  },
}
</script>

<style lang="less" scoped>
.vocieAinBox {
  width: 19px;
  height: 24px;
  overflow: hidden;
  margin-right: 4px;

  .play {
    animation: heart-burst steps(28) 1.2s infinite both;
  }
  @keyframes heart-burst {
    0% {
      width: 0px;
    }
    100% {
      width: 14px;
    }
  }
  .stop {
    animation-play-state: paused;
    width: 19px;
  }
}

.vocieAin {
  width: 17px;
  height: 24px;
  overflow: hidden;
  img {
    width: 14px;
    height: 18px;
  }
}

.vocie {
  display: flex;
  position: relative;
  &_tag {
    width: 8px;
    height: 8px;
    background: #e03131;
    border-radius: 4px;
    position: absolute;
    top: 6px;
    right: -26px;
  }
}

</style>

<style lang="less" scoped>
.video-live {
  .vocie {
    align-items: center;
    .vocie_tag {
      width: 8px;
      height: 8px;
      top: 6px;
      right: -12px;
    }
  }
  .vocieAinBox {
    margin-left: 4px;

  }
}
.voice {
  width: 17px;
  height: 24px;
  background: url(../../assets/icon.png) -34px -22px no-repeat;
}
.active {
  background: url(../../assets/voiceReceive.gif) no-repeat
}
</style>
